export default {
    terms: {
        controllers: 'Buildings',
        name: 'naam',
        location: 'ruimte',
        back: 'terug',
        powerConsumption: 'Stroomverbruik',
        month: 'maand',
        week: 'week',
        day: 'dag',
        hour: 'uur',
        time: 'Tijd',
        off: 'Uit',
        on: 'Aan',
        heating_low: 'Verwarmen: laag',
        heating_medium: 'Verwarmen: middel',
        heating_high: 'Verwarmen: hoog',
        cooling_low: 'Koelen: laag',
        cooling_medium: 'Koelen: middel',
        cooling_high: 'Koelen: hoog',
        monday: 'Maandag',
        tuesday: 'Dinsdag',
        wednesday: 'Woensdag',
        thursday: 'Donderdag',
        friday: 'Vrijdag',
        saturday: 'Zaterdag',
        sunday: 'Zondag',
        save: 'Opslaan',
        cancel: 'Annuleren',
    },
};
